import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

import { ProductReviewAnswerType, ProductReviewUserType } from '@shared/types/product';

export const getUserName = (user?: ProductReviewUserType | null) => {
  const name = [user?.lastName, user?.firstName, user?.secondName]
    .map((item) => item?.trim())
    .filter(Boolean)
    .join(' ');

  return name || 'Пользователь';
};

export const getReviewDate = (date: string | null | undefined) => {
  if (!date) return '';

  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return date;
  }

  return format(parsedDate, 'd MMMM yyyy', { locale: ru });
};

export const getReviewImageUrl = (image: unknown) => {
  if (typeof image === 'string') return image;

  if (!image || typeof image !== 'object') return null;

  const imageRecord = image as Record<string, unknown>;
  const url = imageRecord.url || imageRecord.src || imageRecord.path || imageRecord.imageUrl || imageRecord.original;

  return typeof url === 'string' ? url : null;
};

export const getAnswer = (answer?: ProductReviewAnswerType | null) => {
  const text = answer?.text || answer?.comment;

  if (!text) return null;

  return {
    name: answer?.author || answer?.name || (answer?.user ? getUserName(answer.user) : 'Olevaro'),
    date: getReviewDate(answer?.date || answer?.createdAt),
    text
  };
};
